"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.MAX_NEEDS_PER_BULK_SHIFT_OR_RENEW_ACTION = exports.MAX_NEEDS_PER_BULK_ARCHIVE_ACTION = exports.DEFAULT_NEED_WORKER_SEARCH_RADIUS_KM = exports.DEFAULT_NEED_REQUIRED_CERTIFICATES_LOGICAL_OPERATOR = exports.deriveNeedType = exports.ALLOWED_DUPLICATE_NEED_TYPES = exports.NEED_WORK_RATES = exports.NEED_CONTRACT_TYPES = exports.NEED_REQUIRED_EXPERIENCES = exports.NEED_TYPES = exports.NEED_PRIORITIES = void 0;
const lib_custom_types_1 = require("@backend/lib-custom-types");
exports.NEED_PRIORITIES = (0, lib_custom_types_1.strictUnionArray)()(['NONE', 'LOW', 'MEDIUM', 'HIGH']);
exports.NEED_TYPES = (0, lib_custom_types_1.strictUnionArray)()(['FIXED_DATE', 'LOOSE_DATE', 'ANTICIPATION', 'PROSPECTION']);
exports.NEED_REQUIRED_EXPERIENCES = (0, lib_custom_types_1.strictUnionArray)()([
    'ANY_REQUIRED',
    'NO_EXP_REQUIRED',
    'ONE_MONTH_REQUIRED',
    'THREE_MONTHS_REQUIRED',
    'SIX_MONTHS_REQUIRED',
    'ONE_YEAR_REQUIRED',
    'TWO_FIVE_YEARS_REQUIRED',
    'FIVE_PLUS_YEARS_REQUIRED',
]);
exports.NEED_CONTRACT_TYPES = (0, lib_custom_types_1.strictUnionArray)()([
    'FIXED_TERM',
    'PERMANENT',
    'NON_SEASONAL_TEMPORARY',
    'SEASONAL_TEMPORARY',
    'TEMPORARY',
]);
exports.NEED_WORK_RATES = (0, lib_custom_types_1.strictUnionArray)()([
    'FLEXIBLE',
    'DAY',
    'NIGHT',
    'SATURDAY',
    'SHIFT',
    'SPLIT_SHIFT',
    'STAGGERED_HOURS',
    'SUNDAY_AND_PUBLIC_HOLIDAY',
    'WEEK_END',
    'OVERNIGHT',
]);
exports.ALLOWED_DUPLICATE_NEED_TYPES = {
    ANTICIPATION: ['FIXED_DATE', 'LOOSE_DATE'],
    PROSPECTION: ['FIXED_DATE', 'LOOSE_DATE'],
    FIXED_DATE: ['ANTICIPATION'],
    LOOSE_DATE: ['ANTICIPATION'],
};
const deriveNeedType = ({ companyId, flexibleDates, }) => {
    if (!companyId)
        return 'PROSPECTION';
    return flexibleDates ? 'LOOSE_DATE' : 'FIXED_DATE';
};
exports.deriveNeedType = deriveNeedType;
exports.DEFAULT_NEED_REQUIRED_CERTIFICATES_LOGICAL_OPERATOR = 'OR';
exports.DEFAULT_NEED_WORKER_SEARCH_RADIUS_KM = 30;
exports.MAX_NEEDS_PER_BULK_ARCHIVE_ACTION = 10;
exports.MAX_NEEDS_PER_BULK_SHIFT_OR_RENEW_ACTION = 1000;
